import $ from 'jquery';
import React, { PropTypes } from 'react';
import ReactDOMServer from 'react-dom/server';
import Cookies from 'js-cookie';

const COOKIES_STORE_KEY = 'liphatech.confirm';

export default function bind() {}

export const displayConfirmModalIfRequired = ($button, callback) => {
  const id = $button.attr('data-id');
  const title = $button.attr('data-title');
  const content = $button.attr('data-content');
  const enabled = $button.attr('data-enabled') === 'true';

  if (enabled && id && title && content && !hasAlreadyConfirmedAction(id)) {
    displayConfirmModal(id, title, content, callback);
  } else {
    callback();
  }
};

function displayConfirmModal(id, title, content, callback) {
  // Display modal
  const modal = ReactDOMServer.renderToStaticMarkup(
    <ConfirmModal title={title} content={content} />
  );

  // Appending content to body
  $(document.body).append(modal);

  // Handling approve button
  const $modal = $('#confirm-action-modal');
  $modal
    .modal({
      onApprove: element => {
        const $button = $(element);

        // Checking confirm must be store in cookie (user does not want to be prevented anymore)
        const checkbox = $button
          .closest('.modal')
          .find('input[type="checkbox"]');
        if (checkbox.is(':checked')) {
          storeConfirmationInCookie(id);
        }

        // Execute action and hiding it on executed
        callback();

        return true;
      },
    })
    .modal('show');
}

function getConfirmationCookie() {
  return Cookies.getJSON(COOKIES_STORE_KEY) || {};
}

function hasAlreadyConfirmedAction(id) {
  return getConfirmationCookie().hasOwnProperty(id);
}

function storeConfirmationInCookie(id) {
  const cookie = getConfirmationCookie();
  cookie[id] = true;

  Cookies.set(COOKIES_STORE_KEY, cookie);
}

const ConfirmModal = ({ title, content }) => (
  <div id="confirm-action-modal" className="ui small modal">
    <div className="header">
      <i className="icon warning circle" />
      {title}
    </div>
    <div className="content" style={{ marginBottom: '20px' }}>
      <p>{content}</p>
      <div className="right floated">
        <div className="ui checkbox">
          <input type="checkbox" name="hide" />
          <label>Ne plus afficher cet avertissement</label>
        </div>
      </div>
    </div>
    <div className="actions">
      <div className="ui primary approve button">Confirmer</div>
      <div className="ui cancel button">Annuler</div>
    </div>
  </div>
);

ConfirmModal.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/plugins/confirm-action.js